















import { computed, defineComponent, PropType } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "RestrictedWordConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    value: { type: Boolean, required: true },
    restrictedWords: { type: Array as PropType<string[]>, default: () => [] },
  },
  setup(props) {
    const restrictedWordsString = computed(() => props.restrictedWords.join(", "));
    return { restrictedWordsString };
  },
});
